import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import ExisitingPoliciesForm from "./indexForm";
// import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import { Box } from "@mui/material";
import {
  getRoute,
  getStorageItem,
  makeid,
  setStorageItem,
} from "../../../helpers/utils";
import { useHistory } from "react-router";
import { postWebService } from "../../../helpers/server";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function ExisitingPolicies({ classes: { loaderBox, main } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [errors, setErrors] = useState([]);
  const [modal, setModal] = useState({ open: false, snackbar: false });
  const [isLoaded, setIsLoaded] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [currentAvivaProposals, setCurrentAvivaProposals] = useState([]);
  const [existingAvivaPolicies, setExistingAvivaPolicies] = useState([]);
  const [existingOtherPolicies, setExistingOtherPolicies] = useState([]);
  const [existingPolicies, setExistingPolicies] = useState([]);
  const [policyPremium, setPolicyPremium] = useState({});
  const [touched, setTouched] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    wrapperToken();
  }, []);

  useEffect(() => {}, [orderDetails]);

  useEffect(() => {}, [existingPolicies]);

  useEffect(() => {
    validatePolicyPremium();
  }, [policyPremium]);

  const wrapperToken = async () => {
    try {
      const header = buildWrapperTokenHeader();
      const response = await postWebService("token.php", {}, header);

      setStorageItem("access-token", response.data.access_token);
      getOrder();
    } catch (error) {
      // console.log(error);
    }
  };

  const getOrder = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("orders.php", {
        checksum,
        oid: getStorageItem("oid"),
      });
      const { data } = response;
      const str = data.data.slice(9, -8);
      const result = JSON.parse(atob(str));
      if (result.checksum === checksum) {
        setOrderDetails(result);
        result?.dedupe_stage === "EXISTINGPOLICIES"
          ? navigateTo()
          : fetchExistingPolicies();
      }
    } catch (error) {
      setIsLoaded(true);
    }
  };

  const extractExistingPolicies = ({ data = [] }) => {
    setIsLoaded(true);
    setExistingPolicies(data);

    const avivaPolicies = [];
    const otherPolices = [];
    const proposals = [];
    const policyPremiumObject = {};

    data.map((item) => {
      item.companyNumber == 122
        ? item.isNew
          ? proposals.push(item)
          : avivaPolicies.push(item)
        : otherPolices.push(item);

      // Consider record only if annual premium need to fill manually
      if (!item.annual_premium_custom) {
        policyPremiumObject[item.policyNo] = null;
      }
    });

    setExistingAvivaPolicies(avivaPolicies);
    setExistingOtherPolicies(otherPolices);
    setCurrentAvivaProposals(proposals);
    setPolicyPremium({ ...policyPremiumObject });
  };

  const fetchExistingPolicies = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("policybyorder.php", {
        checksum,
        oid: getStorageItem("oid"),
      });

      extractExistingPolicies(response.data);
    } catch (error) {
      setIsLoaded(true);
    }
  };

  /* Start: Submit Decision */
  const handleChange = (event, item) => {
    let value = event.target.value;
    setPolicyPremium((prev) => ({
      ...prev,
      [item.policyNo]: value ? Number(value) : null,
    }));

    // Show validation only after user starts typing
    setTouched((prev) => ({
      ...prev,
      [item.policyNo]: true,
    }));
  };

  const validatePolicyPremium = () => {
    const isInvalid = Object.values(policyPremium).some(
      (premium) => premium !== "" && Number(premium) < 1000
    );

    setIsButtonDisabled(isInvalid);
  };
  //setFormState(event.target.name, event.target.value);

  const cbSuccess = (data = null) => {
    setIsFormSubmitted(false);

    if (data?.code == 200) {
      navigateTo();
    } else if (data?.code == 403) {
      terminateJourney(
        data?.msg ??
          "Your journey has been terminated as the total annual premium amount exceeds the permitted limit."
      );
    } else {
      setErrors([
        data?.msg ??
          "Unable to process your request. Please contact the support team for assistance.",
      ]);
    }
  };

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setErrors(new Array(error));
  };

  const onSubmit = async () => {
    try {
      setIsFormSubmitted(true);

      const checksum = makeid();
      const response = await postWebService("update-ape.php", {
        checksum,
        oid: getStorageItem("oid"),
        data: Object.keys(policyPremium).length > 0 ? policyPremium : null,
      });

      cbSuccess(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const terminateJourney = (message = "") => {
    setStorageItem("journeyCloseReason", message);

    navigateTo("terminated");
  };
  /* End: Submit Decision */

  const navigateTo = (url = "bankDetails") => {
    history.push({ pathname: getRoute(url) });
  };

  return isLoaded ? (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1} mb={0}>
          <SectionTitle title={"Customer's Existing Policies"} />
        </Box>

        <ExisitingPoliciesForm
          currentAvivaProposals={currentAvivaProposals}
          errors={errors}
          existingAvivaPolicies={existingAvivaPolicies}
          existingOtherPolicies={existingOtherPolicies}
          existingPolicies={existingPolicies}
          handleChange={handleChange}
          isFormSubmitted={isFormSubmitted}
          isButtonDisabled={isButtonDisabled}
          onSubmit={onSubmit}
          orderDetails={orderDetails}
          modal={modal}
          policyPremium={policyPremium}
          touched={touched}
        />
      </Box>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ExisitingPolicies);
